unit GA.DonationClaimStatusSets;

interface

uses
  System.SysUtils;

type
  { Named donation claim-status lists. Add a new on-claim status (AdjustmentPending,
    ClaimReversed, ...) to OnClaim only. Submitted-on-claim, Gift Aid report, locked,
    retain-Claim-ID, OData, and claim SQL are derived from that. }
  TDonationClaimStatusSets = class
  public
    { Scheduled through ClaimReversed. Donations that keep a Claim ID. }
    class function OnClaim: TArray<string>;
    { OnClaim minus leftover Scheduled. Used after the claim has gone to HMRC. }
    class function SubmittedOnClaim: TArray<string>;
    { Donations on a prepared, not-yet-submitted claim. }
    class function PreparedOnClaim: TArray<string>;
    { Charity-wide Giftaid Donations report: Unclaimed plus OnClaim. }
    class function GiftAidReport: TArray<string>;
    class function NonGiftAidReport: TArray<string>;
    { Do not overwrite: Cancelled, Deleted, plus OnClaim. }
    class function Locked: TArray<string>;
    { GIFT_AID_CLAIM.CLAIMSTATUS values that mean the claim has gone to HMRC. }
    class function ClaimSubmittedHeaders: TArray<string>;

    class function Contains(const AStatus: string; const AStatuses: TArray<string>): Boolean;
    class function SqlInList(const AStatuses: TArray<string>): string;
    class function ODataOrEq(const AFieldName: string; const AStatuses: TArray<string>): string;
    class function Join(const AStatuses: TArray<string>; const ASeparator: string): string;
    class function SqlDonationBelongsOnClaim(const AClaimStatusColumn, ADonationStatusColumn: string): string;
  end;

implementation

const
  STATUS_SCHEDULED = 'Scheduled';
  STATUS_UNCLAIMED = 'Unclaimed';

function Without(const AStatuses: TArray<string>; const AExclude: string): TArray<string>;
var
  i, n: Integer;
begin
  SetLength(Result, Length(AStatuses));
  n := 0;
  for i := 0 to High(AStatuses) do
    if not SameText(AStatuses[i], AExclude) then
    begin
      Result[n] := AStatuses[i];
      Inc(n);
    end;
  SetLength(Result, n);
end;

function ConcatHead(const AHead: string; const ATail: TArray<string>): TArray<string>;
var
  i: Integer;
begin
  SetLength(Result, Length(ATail) + 1);
  Result[0] := AHead;
  for i := 0 to High(ATail) do
    Result[i + 1] := ATail[i];
end;

class function TDonationClaimStatusSets.OnClaim: TArray<string>;
begin
  Result := [STATUS_SCHEDULED, 'Submitting', 'Confirmed', 'Claimed', 'Received',
    'AdjustmentPending', 'ClaimReversed'];
end;

class function TDonationClaimStatusSets.SubmittedOnClaim: TArray<string>;
begin
  Result := Without(OnClaim, STATUS_SCHEDULED);
end;

class function TDonationClaimStatusSets.PreparedOnClaim: TArray<string>;
begin
  Result := [STATUS_SCHEDULED];
end;

class function TDonationClaimStatusSets.GiftAidReport: TArray<string>;
begin
  Result := ConcatHead(STATUS_UNCLAIMED, OnClaim);
end;

class function TDonationClaimStatusSets.NonGiftAidReport: TArray<string>;
begin
  Result := ['NonGiftAidable', 'TooOld', 'Unknown', 'NGACustomerRequest'];
end;

class function TDonationClaimStatusSets.Locked: TArray<string>;
begin
  Result := ConcatHead('Cancelled', ConcatHead('Deleted', OnClaim));
end;

class function TDonationClaimStatusSets.ClaimSubmittedHeaders: TArray<string>;
begin
  Result := ['Submitting', 'Acknowledged', 'Confirmed', 'PaymentReceived',
    'Clearing', 'ClaimCleared', 'ClaimRejected'];
end;

class function TDonationClaimStatusSets.Contains(const AStatus: string;
  const AStatuses: TArray<string>): Boolean;
var
  lStatus: string;
  i: Integer;
begin
  lStatus := Trim(AStatus);
  if lStatus = '' then
    Exit(False);

  for i := 0 to High(AStatuses) do
    if SameText(lStatus, AStatuses[i]) then
      Exit(True);

  Result := False;
end;

class function TDonationClaimStatusSets.SqlInList(const AStatuses: TArray<string>): string;
var
  i: Integer;
begin
  Result := '';
  for i := 0 to High(AStatuses) do
  begin
    if i > 0 then
      Result := Result + ', ';
    Result := Result + QuotedStr(AStatuses[i]);
  end;
end;

class function TDonationClaimStatusSets.ODataOrEq(const AFieldName: string;
  const AStatuses: TArray<string>): string;
var
  i: Integer;
begin
  Result := '';
  for i := 0 to High(AStatuses) do
  begin
    if i > 0 then
      Result := Result + ' or ';
    Result := Result + AFieldName + ' eq ' + QuotedStr(AStatuses[i]);
  end;
  if Result <> '' then
    Result := '(' + Result + ')';
end;

class function TDonationClaimStatusSets.Join(const AStatuses: TArray<string>;
  const ASeparator: string): string;
var
  i: Integer;
begin
  Result := '';
  for i := 0 to High(AStatuses) do
  begin
    if i > 0 then
      Result := Result + ASeparator;
    Result := Result + AStatuses[i];
  end;
end;

class function TDonationClaimStatusSets.SqlDonationBelongsOnClaim(
  const AClaimStatusColumn, ADonationStatusColumn: string): string;
begin
  { Not yet submitted (WaitingAuth, Open, Scheduled, and anything else not
    in the submitted list) keeps Scheduled. Submitted claims drop it. }
  Result := Format(
    '((%0:s IN (%1:s) AND %2:s IN (%3:s)) OR (%0:s NOT IN (%1:s) AND %2:s IN (%4:s)))',
    [AClaimStatusColumn, SqlInList(ClaimSubmittedHeaders), ADonationStatusColumn,
     SqlInList(SubmittedOnClaim), SqlInList(PreparedOnClaim)]);
end;

end.
